import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { PROBLEMS } from '../data/content';
export function Problems() {
  return <section className="px-5 py-10" data-id="element-202" data-mp="32516mb0zc1b8">
      <div className="mx-auto max-w-md" data-id="element-203" data-mp="323zip5yv7kc3">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-204" data-mp="322y790dxsvtu">
          Probablemente algo de esto te suene familiar 🫩
        </h2>

        <div className="mt-6 space-y-3" data-id="element-205" data-mp="2t55qdrskhg4c">
          {PROBLEMS.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex items-start gap-3 rounded-xl border border-red-500/40 bg-red-950/35 px-4 py-3.5" data-id="element-206" data-mp="2o5064wommvwa" data-mpi={i}>
              <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400" data-id="element-207" data-mp="39py5dx3syio8" />
              <p className="text-[15px] leading-snug text-red-100" data-id="element-208" data-mp="39nv9iwfyxvbl">{p}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}